module.exports = __webpack_public_path__ + "static/media/b1_p8_clickable_ph.e4358908.png";